import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import util, { delQueStr } from '@tencent/vft-common/util';
import Avatar from '@vip-activity/ui/components/Avatar/Avatar.vue';
import TicketService from '../../../service/ticket';
import Bus from '../../../util/eventBus';
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Avatar: Avatar
  },
  watch: {
    value: function value(val) {
      if (val) {
        this.getMasterUserInfo();
      }
    }
  },
  data: function data() {
    return {
      masterInfo: null
    };
  },
  computed: {
    // 根据链接后的pid查找用户分享的当前的演唱会的信息
    concertInfo: function concertInfo() {
      var pid = util.getUrlParam('pid');
      var list = (this.setting.演出场次 || []).filter(function (v) {
        return v.pid === pid;
      });
      return list.length > 0 ? list[0] : this.setting.演出场次[0];
    }
  },
  methods: {
    launchShare: function launchShare() {
      this.eventBus.$emit('launchShare', {
        action: 'receive',
        activity_name: this.concertInfo.activity_name
      });
    },
    blackTip: function blackTip() {
      var _this = this;

      this.confirm({
        msg: '您的账号存在安全风险，请联系客服处理。',
        align: 'left',
        confirmText: '联系客服',
        confirm: function confirm() {
          _this.openKefu();
        }
      });
    },
    clearKey: function clearKey() {
      var _window = window,
          location = _window.location,
          history = _window.history;

      try {
        var url = location.href;
        var keys = ['uid', 'oid', 'pid'];
        keys.forEach(function (key) {
          url = delQueStr(url, key);
        });

        if (history.replaceState) {
          history.replaceState(null, document.title, url);
        }
      } catch (e) {
        console.error(e);
      }
    },
    close: function close() {
      this.$emit('input', false);
      this.$emit('close');
    },
    getMasterUserInfo: function getMasterUserInfo() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return TicketService.getInviteUserInfo(_this2.oid, _this2.uid).catch(function () {
                  _this2.close();

                  _this2.toast('服务器开小差了，刷新测试');
                });

              case 2:
                res = _context.sent;

                if (res) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return");

              case 5:
                _this2.masterInfo = res.master_info;

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    receiveTicket: function receiveTicket() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var code, res, sCode;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return TicketService.receiveOrder(_this3.oid);

              case 3:
                _this3.clearKey();

                _this3.close();

                _this3.launchShare();

                Bus.$emit('refreshTicketInfo', _this3.concertInfo);
                _context2.next = 16;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](0);
                code = +_context2.t0.code;
                res = _context2.t0.res;
                sCode = res && res.data && res.data.secInfo && res.data.secInfo.iRet;

                if (code === -10003) {
                  _this3.loginTips();
                } else if (code === -10006) {
                  _this3.toast('您已拥有一份电子票，无需重复领取哦~');
                } else if (code === -10008) {
                  _this3.toast('朋友来晚啦，活动已结束~');
                } else if (code === -10009) {
                  _this3.toast('来晚啦，票被其他朋友领完啦~');
                } else if (sCode === 101) {
                  _this3.blackTip();
                } else if (res && res.data && res.data.secInfo) {
                  _this3.shieldRun(res.data.secInfo, function () {
                    _this3.receiveTicket();
                  });
                } else {
                  _this3.toast('啊哦，服务器开小差了，请稍后再试~');
                }

                _this3.close();

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 9]]);
      }))();
    }
  }
};